export default "__VITE_ASSET__Bcj8N5lz__"